<template>
  <div id="filterNav">

    <div class="title-value">Company Options</div>

    <div class="options">
      <div v-ripple class="option" v-for="(option, i) in links" :key="i" :class="{selected: option.route === $route.name}" @click="updateTarget(option)" v-if="hasPermissions(option.permissions)">
        {{ option.title }}
      </div>
    </div>

  </div>
</template>

<script>

  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [permissionMixin],
    data () {
      return {
                
      }
    },
    props: {
      links: {
        required: true,
        type: Object
      },
      navElement: {
        required: false,
        type: Object
      }
    },
    methods: {
      updateTarget (option) {
        app.target = option.route;
        if (this.navElement) this.navElement.target = option.route;
        
        // Set the company nav to reflect the changes in the navigation
        // IMPROVE: This is a reference to the mobileNavigation as well, so this is hacky and not ideal.
        this.app.navigation.company.target = option.route;

        this.$router.push({ name: option.route });
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #filterNav {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $dark;

    .title-value {

      @include fontPrimary500();

      background: $black12;
      padding: 28px 16px;
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: $filterTitle;
      border-bottom: solid 1px $white12;
    }

    .options {

      border-bottom: 1px solid $white12;

      .option {
        @include fontPrimary400;
        @include title();
  
        padding: 12px;
        background: rgba(255, 255, 255, .03);
        box-sizing: border-box;
        color: $white;
        cursor: pointer;
  
        &.selected {
          background: rgba(30,162,149,0.20);
        }
      }
    } 
  }

</style>



// WEBPACK FOOTER //
// src/components/FilterNav.vue